<template>
  <div class="site-page news-page">
    <section class="sub-page-banner news-banner">
      <div class="site-container">
        <h1>资讯中心</h1>
      </div>
    </section>

    <div class="site-container news-wrap">
      <div class="news-tab-card">
        <div class="top-tabs">
          <button
            v-for="item in tabOptions"
            :key="item.value"
            type="button"
            :class="{ active: currentTab === item.value }"
            @click="changeTab(item.value)"
          >
            {{ item.label }}
          </button>
        </div>
      </div>

      <div class="category-row">
        <span
          v-for="cat in categories"
          :key="cat.value"
          class="tag-pill"
          :class="{ active: currentCat === cat.value }"
          @click="currentCat = cat.value"
        >
          {{ cat.label }}
        </span>
      </div>

      <div class="news-grid">
        <article class="news-card" v-for="item in pagedList" :key="item.id" @click="goDetail(item)">
          <div class="cover"><img :src="item.cover" alt=""></div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
          <div class="meta">
            <span>{{ item.tag }}</span>
            <span>{{ item.date }}</span>
          </div>
        </article>
      </div>

      <div v-if="!filteredList.length" class="empty-state">当前筛选下暂无内容</div>

      <div v-if="total > pageSize" class="pager">
        <button type="button" @click="changePage(currentPage - 1)">上一页</button>
        <span
          v-for="page in visiblePages"
          :key="page"
          :class="{ active: currentPage === page }"
          @click="changePage(page)"
        >
          {{ page }}
        </span>
        <button type="button" @click="changePage(currentPage + 1)">下一页</button>
      </div>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import {
  buildNewsDetailPath,
} from '@/data/siteData'
import { getCategoryList, getNewsList } from '@/api'

const NEWS_TYPE_OPTIONS = [
  { label: '商业项目', value: 'biz' },
  { label: '资讯中心', value: 'news' },
  { label: '成功案例', value: 'cases' },
]

const PAGE_SIZE = 8

export default {
  name: 'News',
  data() {
    return {
      currentTab: 'biz',
      currentCat: 'all',
      currentPage: 1,
      pageSize: PAGE_SIZE,
      total: 0,
      loading: false,
      tabOptions: NEWS_TYPE_OPTIONS,
      categories: [{ label: '全部', value: 'all' }],
      newsList: [],
    }
  },
  computed: {
    filteredList() {
      return this.newsList
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    visiblePages() {
      return Array.from({ length: this.totalPages }, (_, index) => index + 1)
    },
    pagedList() {
      return this.newsList
    },
  },
  created() {
    this.fetchCategories()
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler() {
        this.syncTabFromRoute()
      },
    },
    currentCat() {
      this.currentPage = 1
      this.fetchNewsList()
    },
    currentPage() {
      this.fetchNewsList()
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const categories = await getCategoryList()
        if (Array.isArray(categories) && categories.length) {
          this.categories = categories
        }
      } catch (error) {
        this.categories = [{ label: '全部', value: 'all' }]
      } finally {
        this.fetchNewsList()
      }
    },
    async fetchNewsList() {
      this.loading = true
      try {
        const data = await getNewsList({
          page: this.currentPage,
          pageSize: this.pageSize,
          type: this.currentTab,
          category: this.currentCat,
        })
        this.total = Number(data.total || 0)
        this.newsList = Array.isArray(data.list) ? data.list : []
      } catch (error) {
        this.total = 0
        this.newsList = []
      } finally {
        this.loading = false
      }
    },
    syncTabFromRoute() {
      const routeTab = this.$route.query.tab
      const isValid = this.tabOptions.some((item) => item.value === routeTab)
      this.currentTab = isValid ? routeTab : 'biz'
      this.currentPage = 1
      this.fetchNewsList()
    },
    changeTab(tab) {
      if (this.currentTab === tab) {
        return
      }
      this.currentTab = tab
      this.currentPage = 1
      this.$router.replace({
        path: '/news',
        query: { ...this.$route.query, tab },
      })
    },
    goDetail(item) {
      this.$router.push(buildNewsDetailPath(item.id))
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) {
        return
      }
      this.currentPage = page
      window.scrollTo({ top: 240, behavior: 'smooth' })
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.news-banner {
  background-image: url('~@/assets/imgs/ysgj_041@2x.png');
  background-position: center;
  background-size: cover;
}

.news-wrap {
  position: relative;
  z-index: 4;
  margin-top: -36px;
}

.news-tab-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--site-shadow);
  padding: 0 24px;
  overflow: hidden;
}

.top-tabs {
  height: 58px;
  border-bottom: 1px solid #e7edf5;
  display: flex;
  align-items: center;
  gap: 28px;
}

.top-tabs button {
  position: relative;
  border: none;
  background: none;
  color: #7a8595;
  font-size: 16px;
  height: 100%;
  cursor: pointer;
}

.top-tabs button.active {
  color: #2d5f9f;
  font-weight: 700;
}

.top-tabs button.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--site-blue);
}

.category-row {
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.news-grid {
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.news-card {
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.news-card:hover {
  box-shadow: 0 6px 16px rgba(20, 87, 165, 0.09);
  transform: translateY(-2px);
}

.news-card .cover {
  height: 132px;
  overflow: hidden;
  background: #e8f0f8;
}

.news-card .cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-card h3 {
  font-size: 13px;
  color: #465368;
  line-height: 1.45;
  height: 39px;
  overflow: hidden;
  margin: 10px 10px 0;
}

.news-card p {
  margin: 6px 10px 0;
  font-size: 12px;
  color: #98a2af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-card .meta {
  margin: 8px 10px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #a5adba;
}

.empty-state {
  margin: 18px 20px 8px;
  border: 1px dashed #d8e4f1;
  border-radius: 10px;
  padding: 28px 16px;
  text-align: center;
  color: #8a97aa;
  font-size: 13px;
}

.pager {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.pager button,
.pager span {
  min-width: 28px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #7a8595;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  cursor: pointer;
}

.pager span.active {
  background: var(--site-blue);
  color: #fff;
  border-color: var(--site-blue);
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}
</style>
